import { cn } from "../../utils/classnames.js";
import { Button } from "../atoms/button.js";
import { DropdownMenu, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from "../atoms/dropdown-menu.js";
import { useLayoutContext } from "../../hooks/layout-context.js";
import { DropdownMenuContent } from "../molecules/dropdown-menu.js";
import { useCallback } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { Globe } from "lucide-react";
import { useLingui } from "@lingui/react";
import { LOCALE_SELECTOR_TRIGGER_TESTID } from "@bitcart/qa";
import { getLocaleDisplayName } from "@bitcart/core/i18n";
//#region src/components/organisms/locale-selector.tsx
const LocaleSelector = ({ activeLocaleId, optionLocaleIds, handleSelect, triggerVariant = "ghost", classNames, abbreviateOnSmallScreens = false }) => {
	const { _: $__ } = useLingui();
	const createHandleSelect = useCallback((localeId) => () => handleSelect(localeId), [handleSelect]);
	return /* @__PURE__ */ jsxs(DropdownMenu, { children: [/* @__PURE__ */ jsxs(DropdownMenuTrigger, {
		render: /* @__PURE__ */ jsx(Button, { variant: triggerVariant }),
		className: classNames?.trigger,
		"aria-label": $__({
			id: "k_sb6z",
			message: "Select language"
		}),
		"data-testid": LOCALE_SELECTOR_TRIGGER_TESTID,
		children: [
			/* @__PURE__ */ jsx(Globe, {}),
			/* @__PURE__ */ jsx("span", {
				className: cn("text-sm font-medium capitalize", { "max-sm:hidden": abbreviateOnSmallScreens }),
				children: getLocaleDisplayName(activeLocaleId)
			}),
			abbreviateOnSmallScreens && /* @__PURE__ */ jsx("span", {
				className: "text-sm font-medium sm:hidden uppercase",
				children: activeLocaleId
			})
		]
	}), /* @__PURE__ */ jsx(DropdownMenuContent, {
		className: "w-48",
		children: /* @__PURE__ */ jsx(DropdownMenuGroup, { children: optionLocaleIds.map((localeId) => /* @__PURE__ */ jsx(DropdownMenuItem, {
			onClick: createHandleSelect(localeId),
			render: /* @__PURE__ */ jsx(Button, {
				variant: localeId === activeLocaleId ? "accent" : "ghost",
				className: cn("focus-visible:ring-transparent", { "text-foreground": localeId === activeLocaleId }),
				"aria-label": getLocaleDisplayName(localeId)
			}),
			children: /* @__PURE__ */ jsx("span", {
				className: "w-full text-left capitalize",
				children: getLocaleDisplayName(localeId)
			})
		}, localeId)) })
	})] });
};
const LayoutLocaleSelector = (props) => {
	const { layoutConfig: { i18n: { activeLocale, availableLocales } } } = useLayoutContext();
	return /* @__PURE__ */ jsx(LocaleSelector, {
		...props,
		activeLocaleId: activeLocale,
		optionLocaleIds: availableLocales
	});
};
//#endregion
export { LayoutLocaleSelector, LocaleSelector };

//# sourceMappingURL=locale-selector.js.map